export const ACTION_SETVIEWER3D_CONFIG = "SET_VIEWER_3D_CONFIG";
export const ACTION_CLEARVIEWER3D_CONFIG = "CLEAR_VIEWER_3D_CONFIG";